const en = {
    menu:{
    	list:[
    		{href:'/index',name:'Home'},
    		{href:'/product',name:'Product'},
    		{href:'/news',name:'News'},
    		{href:'/video',name:'Case'},
        {href:'/about',name:'About'},
    		{href:'/contact',name:'Contact'},
    	],
		bottom:[
			{
				title: 'Introduction',
				url: [
					{href:'/contact',name:'contact'},
					{href:'/about',name:'about'},
				]
			},
			{
				title: 'Services',
				url: [
					{href:'/product',name:'product'},
					{href:'/news',name:'news'},
				]
			},
			{
				title: 'Provisions',
				url: [
					{href:'/',name:'clause'},
				]
			},
		]
    },
	about:{
		explain:[
			{a:'2008',b:'year',c:'Founded in 2008'},
			{a:'2',b:'million',c:'More than 2 million hours of safe operation'},
			{a:'1000',b:'strip',c:'More than 1,000 have been sold'},
			{a:'80',b:'each',c:'Business covers more than 80 cities in China'},
		],
		details:[
			{text:'Founded in 2008, Foshan Dinovor Packaging Technology Co., Ltd. is a high-tech enterprise integrating R & D, design, manufacturing and installation. We are specialized in the research and development of ceramic wall and floor tile automatic packing equipment. The company follows the development tenet of "market-oriented, R & D-driven and quality-oriented core competitiveness" to serve the ceramic enterprises and contribute to the production automation and sustainable development of the ceramic industry.'},
			{text:'Dinovor company has strong R & D and innovation ability. The R & D automation technology of ceramic tile sorting, ceramic tile turning, ceramic tile laminating, ceramic tile lining paper, brick stack uploading, brick stack straightening, brick stack angle, carton forming, brick package binding, brick package rotation, brick package turning, brick package stacking and so on has won many national invention patents, and is widely used in the production of automatic ceramic tile sorting and packaging, Its advanced functional design and stable and reliable equipment performance have won the unanimous praise of users at home and abroad. The products have been sold all over the world, and the export market has accounted for half of the company’s total sales. The products have obvious technical advantages in the industry, and have also been generally recognized and imitated by the ceramic equipment industry.'},
			{text:'At present, the company and Italian inkjet machine carry out extensive cooperation, strong combination, complementary advantages, resource sharing, it has been proved that the choice of Dinovor is the choice of partners for common progress!'},
		]
	},
	corp:{
		name: 'Dinovor Packaging Technology Co., Ltd',
		address: 'Address: 14 Xingye Road, C District, Shishan Industrial Park, Nanhai, Foshan',
		Telephone: 'Telephone：0757-86689109',
		Email: 'E-mail：dinovormarketing@163.com',
	},
	contact:{
		text:'Foshan Dinovor Packaging Technology Company Ltd, is a high-technology enterprise, specializing in research and development, design, manufacture, and installation. Concentrates in the design, development and production of the automated ceramic tiles sorting/packaging machinery. The company’s motto is“quality is power”, With this belief, Dinovor strives to positively contribute to the automation and sustainable growth of the construction ceramic industry.',
		list01:{
		  title:'Customer service',
		  text1:'Company address：14 Xingye West Road, C District, Shishan Science and Technology Industrial Park, Nanhai District, Foshan City',
		  text2:'Telephone / fax：15118799738  Miss Huang',
		  text3:'Email：dinovormarketing@163.com',
		  text4:'QQ：2352221613',
		  text5:'Marketing Manager: Manager He 13927798980'
		},
		list02:{
		  title:'Business cooperation',
		  text1:'South China：',
		  text2:'East China：',
		  text3:'Central China：',
		  text4:'Overseas：'
		},
		online:{
			text:'Can submit comments or suggestions to us',
			name: 'name',
			phone: 'phone',
			Email: 'Email',
			message: 'message',
			submit: 'submit',
		}
	},
	news:{
		nav:[
			{id: 1,name: 'corporate'},
			{id: 2,name: 'industry'}
		]
	},
	honor:{
		nav:[
			{id: 1,name: 'patent'},
			{id: 2,name: 'honor'}
		]
	},
	parameter : 'parameter',
}
export default en;



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js